import {Pipe, PipeTransform} from '@angular/core';
import {Geometry} from '@turf/helpers';
import {Utils} from '../utils.class';
import LatLngBounds = google.maps.LatLngBounds;

@Pipe({
    name: 'intersects'
})
export class IntersectsPipe implements PipeTransform {
    transform(latLngBounds: LatLngBounds, bbox: Geometry, ...locations: Geometry[]): boolean {
        if (!latLngBounds || !locations || locations.length === 0 || !locations[0]) {
            return false;
        }
        const bboxVisible = bbox ? latLngBounds.intersects(new google.maps.LatLngBounds(...Utils.convertGeometry(bbox))) : false;
        return bboxVisible || locations.some(location => Utils.convertGeometry(location).some(geo => latLngBounds.contains(geo)));
    }
}
